import type { Camera, SceneControl } from '@anov/3d-core'
import { Vector3, lib, use } from '@anov/3d-core'
import type ControlBaseModule from '../base'

const { PointerLockControls } = lib

/**
 * @class FirstViewControl - First view control module
 *
 * 贴地 (First View) 控制模块
 */

class FirstViewControl implements ControlBaseModule {
  camera: Camera
  dom: HTMLElement
  control: lib.PointerLockControls
  sceneControl: SceneControl

  velocity = new Vector3()

  private moveForward = false
  private moveBackward = false
  private moveLeft = false
  private moveRight = false
  private canJump = false

  private direction = new Vector3()
  private prevTime = performance.now()
  private cancellation: () => void

  constructor(camera: Camera, dom: HTMLElement, sceneControl: SceneControl) {
    this.camera = camera
    this.dom = dom
    this.sceneControl = sceneControl

    this.control = new PointerLockControls(camera, document.body)
    this.dom.addEventListener('click', this.control.lock)
    this.registerEvent()

    this.cancellation = use.useframe(this.sceneControl, () => {
      this.update()
    })
  }

  /**
   * registerEvent
   */
  private registerEvent() {
    const onKeyDown = (event: KeyboardEvent) => {
      switch (event.code) {
        case 'ArrowUp':
        case 'KeyW':
          this.moveForward = true
          break

        case 'ArrowLeft':
        case 'KeyA':
          this.moveLeft = true
          break

        case 'ArrowDown':
        case 'KeyS':
          this.moveBackward = true
          break

        case 'ArrowRight':
        case 'KeyD':
          this.moveRight = true
          break

        case 'Space':
          if (this.canJump === true)
            this.velocity.y += 5
          this.canJump = false
          break
      }
    }

    const onKeyUp = (event: KeyboardEvent) => {
      switch (event.code) {
        case 'ArrowUp':
        case 'KeyW':
          this.moveForward = false
          break

        case 'ArrowLeft':
        case 'KeyA':
          this.moveLeft = false
          break

        case 'ArrowDown':
        case 'KeyS':
          this.moveBackward = false
          break

        case 'ArrowRight':
        case 'KeyD':
          this.moveRight = false
          break
      }
    }

    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('keyup', onKeyUp)
  }

  private update() {
    const time = performance.now()

    if (this.control.isLocked) {
      const delta = (time - this.prevTime) / 1000

      this.velocity.x -= this.velocity.x * 10.0 * delta
      this.velocity.z -= this.velocity.z * 10.0 * delta
      this.velocity.y -= 9.8 * 100.0 * delta

      this.direction.z = Number(this.moveForward) - Number(this.moveBackward)
      this.direction.x = Number(this.moveRight) - Number(this.moveLeft)
      this.direction.normalize()

      if (this.moveForward || this.moveBackward)
        this.velocity.z -= this.direction.z * 100.0 * delta

      if (this.moveLeft || this.moveRight)
        this.velocity.x -= this.direction.x * 100.0 * delta

      this.control.moveRight(-this.velocity.x * delta)
      this.control.moveForward(-this.velocity.z * delta)
      this.control.getObject().position.y += (this.velocity.y * delta)

      if (this.control.getObject().position.y < 2) {
        this.velocity.y = 0
        this.control.getObject().position.y = 1.8

        this.canJump = true
      }
    }

    this.prevTime = time
  }

  dispose() {
    this.cancellation()
  }

  // 检测专用
}

export default FirstViewControl